/**
 * Adds an observer to timeline nodes and highlights them
 * when they scroll past the middle of the page
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  const nodes = rootElement.querySelectorAll('.sdc-timeline-node');
  if (!nodes.length) {
    return;
  }

  const options = {
    rootMargin: '0% 0% -50% 0%'
  };

  const observer = new IntersectionObserver(checkNodes, options);
  nodes.forEach(node => observer.observe(node));
}

/**
 * Checks nodes and sets class based on visibility
 * @param {object} nodes
 */
function checkNodes(nodes) {
  nodes.forEach(node => node.target.classList.toggle('sdc-timeline-node--active', node.isIntersecting));
}
